/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterpresetwarm2Inputs */

const en_filterpresetwarm2 = /** @type {(inputs: Filterpresetwarm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm`)
};

const de_filterpresetwarm2 = /** @type {(inputs: Filterpresetwarm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm`)
};

/**
* | output |
* | --- |
* | "Warm" |
*
* @param {Filterpresetwarm2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterpresetwarm2 = /** @type {((inputs?: Filterpresetwarm2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterpresetwarm2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterpresetwarm2(inputs)
	return de_filterpresetwarm2(inputs)
});
export { filterpresetwarm2 as "filterPresetWarm" }